import type { DeviceVehicle } from '@cobliteam/api-lib/src/dashboard/device/definitions';
import GrahpQLVehicleRequester from '@cobliteam/api-lib/src/dashboard/vehicle/GrahpQLVehicleRequester';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

// Lazy instantiation to avoid circular dependency issues
const getVehicleRequester = () => new GrahpQLVehicleRequester();

const QUERY_KEY = 'VEHICLE_DEVICES';

const useVehicleDevices = (vehicleGroupsIds?: string[], options?: Partial<UseQueryOptions<DeviceVehicle[]>>) => {
  return useQuery<DeviceVehicle[]>({
    queryKey: [QUERY_KEY, vehicleGroupsIds],
    queryFn: () => getVehicleRequester().getVehiclesWithDevices(vehicleGroupsIds),
    ...options,
  });
};

export default { useVehicleDevices };
